import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import NumberFormat from 'react-number-format';

// Components
import SuggestedProducts from './../SuggestedProducts';
import UpdateQtyCell from './UpdateQtyCell';
import DeleteCell from './DeleteCell';
import TaxRow from './TaxRow';

// State
import { removeCartProduct, getCart } from '../../store/actions/cart';
import { revertCheckoutAfterCartChanged } from '../../store/actions/checkout';

// CSS
import '../../css/cart.css';
import '../../css/cart-item.css';

class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shoppertrack: '',
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // ** Note: I had to use state here and NOT props, because props ended up not changing to nextProps immediately.
        // Why....? WHO KNOWS!
        if (
            !!nextProps.cart.shoppertrack &&
            this.state.shoppertrack !== nextProps.cart.shoppertrack
        ) {
            this.setState(
                {
                    shoppertrack: nextProps.cart.shoppertrack,
                },
                () => this.props.getCart()
            );
        }
    }

    render() {
        const items = this.props.cart.items ? this.props.cart.items : [];
        const codes = this.props.cart.codes;

        let title = 'Cart';
        if (this.props.siteInfo.site) {
            title = this.props.siteInfo.site.title + ' | Cart';
        }

        const helmet = (
            <Helmet>
                <title>{title}</title>
            </Helmet>
        );

        // Set up tax section
        let taxRows = null;
        if (this.props.cart.taxes) {
            taxRows = Object.keys(this.props.cart.taxes).map((tax_type) => {
                const tax = this.props.cart.taxes[tax_type];
                if (tax > 0 && tax_type !== 'total') {
                    return <TaxRow key={tax_type} tax_type={tax_type} tax={tax} />;
                } else {
                    return null;
                }
            });
        }

        return (
            <div className="body_container pt2 pb2">
                {helmet}

                <main className="product_section">
                    <h1>Cart</h1>
                    {items.length ? (
                        <div className="cart-summary">
                            <table className="cart">
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Sku</th>
                                        <th>Price</th>
                                        <th className="qty-cell">Qty</th>
                                        <th>Total</th>
                                        <th className="delete-cell" />
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item, i) => {
                                        return (
                                            <tr key={item.id} className="cart-item">
                                                <td className="cart-summary-item">
                                                    <div className="item-title">
                                                        <Link
                                                            to={`/${
                                                                item.categories[0]
                                                                    .permalink
                                                            }/product/${item.permalink}`}
                                                        >
                                                            {item.title}
                                                        </Link>
                                                    </div>
                                                    {item.variant && (
                                                        <div className="line-item">
                                                            <span className="line-title">
                                                                {item.variant.title}
                                                            </span>
                                                        </div>
                                                    )}
                                                </td>
                                                <td>{item.sku}</td>
                                                <td>
                                                    <NumberFormat
                                                        value={item.price_final}
                                                        displayType={'text'}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator={true}
                                                        prefix={'$'}
                                                    />
                                                </td>
                                                <td className="qty-cell">
                                                    <UpdateQtyCell product={item} />
                                                </td>
                                                <td>
                                                    <NumberFormat
                                                        value={item.total}
                                                        displayType={'text'}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator={true}
                                                        prefix={'$'}
                                                    />
                                                </td>
                                                <td className="delete-cell">
                                                    <DeleteCell product={item} />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    {codes.map((code, i) => {
                                        if (code.code_type === 'general') {
                                            return (
                                                <tr
                                                    key={i}
                                                    className="cart-item coupon-item"
                                                >
                                                    <td>
                                                        <div className="coupon-item-title">
                                                            {code.code}
                                                        </div>
                                                        <div>Coupon</div>
                                                    </td>
                                                    <td />
                                                    <td />
                                                    <td className="qty-cell" />
                                                    <td>
                                                        <NumberFormat
                                                            value={code.value}
                                                            displayType={'text'}
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            thousandSeparator={true}
                                                            prefix={
                                                                code.sale_type ===
                                                                'dollar'
                                                                    ? '$'
                                                                    : ''
                                                            }
                                                            suffix={
                                                                code.sale_type ===
                                                                'percentage'
                                                                    ? '%'
                                                                    : ''
                                                            }
                                                        />
                                                    </td>
                                                    <td className="delete-cell">
                                                        <DeleteCell
                                                            type={'coupon'}
                                                            item={code}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        } else {
                                            return (
                                                <tr
                                                    key={i}
                                                    className="cart-item coupon-item"
                                                >
                                                    <td colSpan="5">
                                                        <div className="coupon-item-title">
                                                            {'Coupon (' + code.code + ')'}
                                                        </div>
                                                        <div>{code.message}</div>
                                                    </td>
                                                    <td className="delete-cell">
                                                        <DeleteCell
                                                            type={'coupon'}
                                                            item={code}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    })}
                                    {this.props.cart.shipping && (
                                        <tr className="cart-item value-row">
                                            <td colSpan="4">
                                                <div>Shipping</div>
                                                <div>
                                                    {this.props.cart.shipping.title}
                                                </div>
                                            </td>
                                            <td>
                                                <NumberFormat
                                                    value={this.props.cart.shipping.cost}
                                                    displayType={'text'}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    prefix={'$'}
                                                />
                                            </td>
                                            <td className="delete-cell" />
                                        </tr>
                                    )}
                                    {taxRows}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan="4">Total:</th>
                                        <th className="qty-cell" data-hbs-id="cart-total">
                                            <div className="hbs-cart-total">
                                                <NumberFormat
                                                    value={this.props.cart.total}
                                                    displayType={'text'}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    prefix={'$'}
                                                />
                                            </div>
                                        </th>
                                        <th className="delete-cell" />
                                    </tr>
                                </tfoot>
                            </table>

                            <Link className="btn btn--red btn--continue" to={`/checkout`}>
                                Continue to checkout
                            </Link>
                        </div>
                    ) : (
                        <div>You do not have any items in your shopping cart!</div>
                    )}
                </main>
                <SuggestedProducts />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        siteInfo: state.siteInfo,
        cart: state.cart,
    };
};

export default connect(
    mapStateToProps,
    { removeCartProduct, revertCheckoutAfterCartChanged, getCart }
)(Cart);



// WEBPACK FOOTER //
// ./src/components/cart/Cart.js